import LuckyDrawPage from "./luckyDraw.container";

export default LuckyDrawPage;
